
import { useEffect } from "react";
import confetti from "canvas-confetti";

export const useConfetti = () => {
  useEffect(() => {
    const duration = 8 * 1000; // 8 seconds celebration (increased from 5)
    const animationEnd = Date.now() + duration;
    
    const randomInRange = (min: number, max: number) => {
      return Math.random() * (max - min) + min;
    };
    
    // Enhanced color palette with more vibrant colors
    const colors = [
      '#FBC528', // Primary yellow
      '#FFD452', // Light yellow
      '#407096', // Mid blue
      '#80A7C7', // Light blue
      '#012B48', // Dark blue
      '#F5F7FB', // Light background
      '#FFFFFF', // White
      '#FFA726', // Bright orange
      '#FF5252', // Red
      '#CDDC39', // Lime
      '#64FFDA', // Teal
    ];
    
    // Create a fireworks-like burst effect
    const fireworkEffect = () => {
      const originX = randomInRange(0.2, 0.8);
      const originY = randomInRange(0.2, 0.4);
      
      // Initial burst
      confetti({
        particleCount: randomInRange(80, 150),
        spread: randomInRange(60, 120),
        origin: { x: originX, y: originY },
        colors: colors,
        ticks: 300,
        gravity: 1,
        scalar: randomInRange(1.2, 1.8),
        drift: randomInRange(-0.5, 0.5),
        shapes: ['circle', 'square', 'star'],
        zIndex: 200,
      });
      
      // Secondary smaller bursts
      setTimeout(() => {
        confetti({
          particleCount: randomInRange(30, 60),
          spread: randomInRange(50, 90),
          origin: { 
            x: originX + randomInRange(-0.1, 0.1), 
            y: originY + randomInRange(-0.1, 0.1) 
          },
          colors: colors,
          ticks: 200,
          gravity: 0.8,
          scalar: randomInRange(0.8, 1.2),
          zIndex: 200,
        });
      }, 150);
    };
    
    // Standard confetti sprays
    const fireConfetti = () => {
      confetti({
        particleCount: randomInRange(40, 80),
        spread: randomInRange(50, 100),
        origin: { 
          x: randomInRange(0.1, 0.9), 
          y: randomInRange(0.1, 0.5) 
        },
        colors: colors,
        ticks: 300,
        gravity: randomInRange(0.8, 1.2),
        scalar: randomInRange(0.9, 1.5),
        drift: randomInRange(-0.5, 0.5),
        angle: randomInRange(0, 360),
        shapes: ['circle', 'square'],
        zIndex: 200,
      });
    };
    
    // Shower confetti from the top
    const showerConfetti = () => {
      confetti({
        particleCount: randomInRange(15, 30),
        angle: 270,
        spread: randomInRange(30, 70),
        origin: { x: randomInRange(0.2, 0.8), y: 0 },
        colors: colors,
        ticks: 400,
        gravity: 0.7,
        scalar: randomInRange(0.8, 1.2),
        drift: randomInRange(-1, 1),
        zIndex: 200,
      });
    };
    
    // Fire initial bursts
    const initialBursts = 6; // Increased from 4
    for (let i = 0; i < initialBursts; i++) {
      setTimeout(() => fireworkEffect(), i * 300);
    }
    
    // Main confetti interval
    const confettiInterval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      
      if (timeLeft <= 0) {
        return clearInterval(confettiInterval);
      }
      
      // Random confetti type
      const confettiType = Math.random();
      if (confettiType < 0.3) {
        fireworkEffect();
      } else if (confettiType < 0.7) {
        fireConfetti();
      } else {
        showerConfetti();
      }
      
    }, 450);
    
    // Canyon confetti - shoots from left and right sides
    const canyonInterval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      
      if (timeLeft <= 0) {
        return clearInterval(canyonInterval);
      }
      
      // Left side
      confetti({
        particleCount: 20,
        angle: 60,
        spread: 40,
        origin: { x: 0, y: 0.7 },
        colors: colors,
      });
      
      // Right side
      confetti({
        particleCount: 20,
        angle: 120,
        spread: 40,
        origin: { x: 1, y: 0.7 },
        colors: colors,
      });
      
    }, 1200);
    
    return () => {
      clearInterval(confettiInterval);
      clearInterval(canyonInterval);
    };
  }, []);
};
